export interface Registration {
  id: string;
  type: RegistrationType;
  state: RegistrationState;
  extraTickets: number;
}

export interface RegistrationApiInteractionEntity extends ApiInteractionEntity {
  stageUnstageLoading: boolean;
}

export type RegistrationType = 'single' | 'group';

export enum RegistrationState {
  Draft = 'draft',
  Staging = 'staging',
  Submitted = 'submitted',
  IGotRemoved = 'iGotRemoved', //state exists only in frontend
  Deleted = 'deleted', //state exists only in frontend
}

export interface ApiInteractionEntity {
  isLoading: boolean;
  error: string | undefined;
}

export type GenericInteractionErrors = '';

export interface TypedApiInteractionEntity<T, ErrorType> {
  object: T | undefined;
  isLoading: boolean;
  error: ErrorType | undefined;
}

export interface RegistrationMemberUserInfo {
  id: string | undefined;
  givenName: string;
  surname: string;
}

export interface RegistrationMemberInfo {
  id: string;
  givenName: string;
  surname: string;
  verified: boolean;
}

export interface RegistrationMember extends ApiInteractionEntity {
  id: string;
  isMaster: boolean;
  verified: boolean;
  userinfo: RegistrationMemberUserInfo;
}

export interface RetrieveRegistrationInfo {
  drawId: string;
  registrationId: string;
}
